<!--<mat-expansion-panel expanded>-->
<!--  <mat-expansion-panel-header>-->
<!--    <mat-panel-title>-->
<!--      <h4>Upload de Arquivo</h4>-->
<!--    </mat-panel-title>-->
<!--  </mat-expansion-panel-header>-->
<div class="mb-4 flex justify-end">
  <div class="flex justify-center g-2">
    <button
      mat-raised-button
      color="primary"
      class="ml-2 btn-upload"
      (click)="uploadFiles()"
    >
      Enviar Arquivo(s)
      <mat-icon>cloud_upload</mat-icon>
    </button>
  </div>
</div>
<div>
  @if (!loading) {
    @if (documents.length > 0) {
      <div class="tab-overflow">
        <table mat-table [dataSource]="tableDocuments" class="mat-elevation-z8">
          @for (column of columnsDocuments; track column.keyColumn) {
            <ng-container matColumnDef="{{ column.keyColumn }}">
              <th mat-header-cell *matHeaderCellDef>
                {{ column.description }}
              </th>
              <td mat-cell *matCellDef="let doc">
                @if (column.keyColumn == 'action') {
                  <div class="flex gap-3">
                    <!--                    <mat-icon-->
                    <!--                      class="btn-icon-outline"-->
                    <!--                      fontIcon="edit"-->
                    <!--                      (click)="editDocument(doc)"-->
                    <!--                    ></mat-icon>-->
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="download"
                      (click)="downloadDocument(doc)"
                    ></mat-icon>
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteDocument(doc)"
                    ></mat-icon>
                  </div>
                } @else if (column.keyColumn == 'tipo') {
                  Contrato
                } @else {
                  {{ doc[column.key] }}
                }
              </td>
            </ng-container>
          }
          <tr
            mat-header-row
            class="style-header"
            *matHeaderRowDef="displayedColumnsDocuments"
          ></tr>
          <tr
            mat-row
            class="style-row"
            *matRowDef="let row; columns: displayedColumnsDocuments"
          ></tr>
        </table>
        <mat-paginator
          [length]="totalDocuments"
          [pageSize]="rows"
          [pageIndex]="page - 1"
          (page)="onPageChange($event.pageIndex + 1)"
        >
        </mat-paginator>
      </div>
    } @else {
      <!--      <div class="text-gray-500 p-4 text-center w-12/12">-->
      <!--        Nenhum arquivo localizado.-->
      <!--      </div>-->
    }
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
<!--</mat-expansion-panel>-->
